<div class="quick-search">
  <div class="quick-search__input qs-input" [ngClass]="{'qs-input--open':proposalPopoverOpen}">
    <div class="badge-proposal" #badgeWrapper>
      <div *ngFor="let proposal of selectedProposal| slice:0:badgeSliceEnd" (click)="deleteProposal(proposal)">{{proposal.Text}}</div>
      <i *ngIf="badgeExpendNumber>0" class="fas fa-angle-double-down badge-proposal__expend-btn" [ngbPopover]="expendProposal" placement="bottom" [autoClose]="'outside'" popoverClass="custom-popover"></i>
      <ng-template #expendProposal>
        <div class="expend-proposal-popover">
          <div *ngFor="let proposal of selectedProposal" (click)="deleteProposal(proposal)"><div>{{proposal.Text}}</div><i class="fas fa-times"></i></div>
        </div>
      </ng-template>
    </div>

    <div class="qs-input__search" #searchWrapper>
      <input type="text" [placeholder]="selectedMode?.titre ? selectedMode?.titre : ''" [(ngModel)]="searchTerm" (input)="onSearch()" (click)="openSearch($event)" (keyup)="getArrowKeys($event)" />
    </div>
    <div class="qs-input__btn-search">
      <button class="btn-mode-selector" (click)="openModeSelector($event)"><i class="fas fa-caret-down"></i></button>
      <button class="btn-search"><i class="fas fa-search"></i></button>
    </div>
  </div>

  <div class="proposal-popover" #proposalPopover>
    <ng-container *ngIf="noProposal;else proposalList">
      <div class="proposal-popover__option q-c-danger q-bold">Aucun résultat</div>
    </ng-container>
    <ng-template #proposalList>
      <div class="proposal-popover__main">
        <cdk-virtual-scroll-viewport appendOnly itemSize="20" maxBufferPx="400" minBufferPx="340" class="example-viewport h-100">
          <div class="proposal-popover__option" [ngClass]="{'proposal-popover__option--selected':qsProposal.Selected}" *cdkVirtualFor="let qsProposal of searchResults|slice:0:proposalSlice" (click)="selectProposal(qsProposal)" [attr.data-sectionvalue]="qsProposal.Value">{{qsProposal.Text}}</div>
        </cdk-virtual-scroll-viewport>
      </div>
      <div *ngIf="displayShowMore" class="proposal-popover__footer" (click)="showMoreProposal($event)"><a class="proposal-popover__show-more" >Afficher plus ...</a></div>
      <div class="proposal-popover__footer proposal-popover__option" (click)="containProposal()"><strong>contient : </strong>{{searchTerm}}</div>

      <!--<div class="proposal-popover__header"><div class="proposal-popover__start-with"><div>contient :</div>{{searchTerm}} </div>--> <!--<button class="proposal-popover__btn-enter"><i class="fas fa-level-down-alt fa-rotate-90"></i><div>Entrée</div></button>--><!--</div>-->

    </ng-template>
  </div>

  <div class="mode-selector" #modeSelector>
    <div *ngFor="let searchMode of searchModes" class="mode-selector__option" [ngClass]="{'mode-selector__option--active' :searchMode.selected}" (click)="selectMode(searchMode)">
      <div class="mode-selector__option-check"><i class="fas fa-check"></i></div>
      <div>{{searchMode.titre}}</div>
    </div>
  </div>
</div>
